import { type FC } from "react";
import { Salaries, type SalariesProps } from "@legacy_user_frontend/components/ui_parts/salaries";
import { Shop } from "./src/Shop";
import { ShopAccordion, type ShopAccordionProps } from "./src/ShopAccordion";
import * as styles from "./styles.css";

type RequirementsProps = {
  dream: string;
  commitment: string;
  requirements: {
    clientShops: {
      totalNumber: ShopAccordionProps["totalNumber"];
      shopInformations: ShopAccordionProps["shopInformations"] | [];
    };
    salaries: SalariesProps["salaries"] | [];
  };
  clientShopsEvent: {
    clientShopsGaAction: ShopAccordionProps["gaAction"];
    clientShopsGaLabels: ShopAccordionProps["gaLabels"];
  };
  isSp: boolean;
  query: string;
  className?: string;
};

export const DetailedInformation: FC<RequirementsProps> = ({
  dream,
  commitment,
  requirements: {
    salaries,
    clientShops: { totalNumber, shopInformations },
  },
  clientShopsEvent: { clientShopsGaAction, clientShopsGaLabels },
  isSp,
  query,
  className,
}) => (
  <div className={className}>
    <dl className={styles.table}>
      <dt>
        <span>
          <i className="icon-yen" />
          <span className={styles.tableTitle}>給与</span>
        </span>
      </dt>
      <dd>{salaries && salaries.length > 0 && <Salaries salaries={salaries} />}</dd>
      {dream && (
        <>
          <dt className="dream-and-commitment">想い</dt>
          <div className="dream-and-commitment-wrapper">
            <dd className="dream-and-commitment">{dream}</dd>
          </div>
        </>
      )}
      {commitment && (
        <>
          <dt className="dream-and-commitment">
            こだ
            <br className={styles.dreamAndCommitmentBr} />
            わり
          </dt>
          <div className="dream-and-commitment-wrapper">
            <dd className="dream-and-commitment">{commitment}</dd>
          </div>
        </>
      )}
      <dt>
        <span>
          <i className="icon-location" />
          <span className={styles.tableTitle}>店舗</span>
        </span>
      </dt>
      <dd className="js-link-expand__unlink">
        {((isSp && totalNumber > 1) || (!isSp && totalNumber > 3)) &&
          shopInformations.length > 0 && (
            <ShopAccordion
              totalNumber={totalNumber}
              shopInformations={shopInformations}
              gaAction={clientShopsGaAction}
              gaLabels={clientShopsGaLabels}
              isSp={isSp}
              query={query}
            />
          )}
        {((isSp && totalNumber <= 1) || (!isSp && totalNumber <= 3)) &&
          shopInformations.length > 0 && (
            <Shop
              totalNumber={totalNumber}
              shopInformations={shopInformations}
              gaAction={clientShopsGaAction}
              gaLabels={clientShopsGaLabels}
              isSp={isSp}
              query={query}
            />
          )}
      </dd>
    </dl>
  </div>
);
